import styled from '@emotion/styled';

export const Wrapper = styled.div`
  width: 100%;
`;
